import type { CSSProperties, ReactNode } from 'react';

export const STAGGER_REVEAL_STEP_MS = 150;
export const STAGGER_TOOLBAR_BASE_DELAY_MS = 500;

export interface StaggerRevealProps {
  children: ReactNode;
  /** Índice secuencial del elemento en la coreografía. */
  index: number;
  enabled?: boolean;
  /** Variante de entrada: bloques desde abajo o toolbar desde arriba. */
  variant?: 'up' | 'down';
  className?: string;
  style?: CSSProperties;
}

export function getStaggerDelayMs(index: number, stepMs = STAGGER_REVEAL_STEP_MS): number {
  return Math.max(0, index) * stepMs;
}

export function StaggerReveal({
  children,
  index,
  enabled = false,
  variant = 'up',
  className = '',
  style,
}: StaggerRevealProps) {
  if (!enabled) {
    return <>{children}</>;
  }

  const animationClass = variant === 'down' ? 'stagger-reveal--down' : 'stagger-reveal--up';

  return (
    <div
      className={[
        'will-change-[opacity,transform]',
        animationClass,
        'print:!animate-none print:!opacity-100 print:!transform-none',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        animationDelay: `${getStaggerDelayMs(index)}ms`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
